/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {LeadDto} from "./leadDto.zod";
import {PaginationMeta2} from "./paginationMeta2.zod";

export const PaginatedLeadDto = zod.object({
  items: zod.array(LeadDto),
  meta: PaginationMeta2,
});

export type PaginatedLeadDto = zod.input<typeof PaginatedLeadDto>;
export type PaginatedLeadDtoOutput = zod.output<typeof PaginatedLeadDto>;
